import { type IEmbedYouTube } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function Youtube ({ id }: IEmbedYouTube) {
  return (
    <iframe
      allowFullScreen
      className={styles.ytIframe}
      loading='lazy'
      src={`https://www.youtube.com/embed/${id}?allowfullscreen=true&autoplay=0&border=0&wmode=opaque&enablejsapi=1&controls=1&showinfo=0`}
    />
  );
}
